export {
  SearchViewModeProvider as ViewModeProvider,
  useSrpViewMode,
  type ViewMode,
} from '../../_shell/SearchViewModeContext';
